import { cn } from '@civilgrid/ui/utils';
import type React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  subject?: string;
  email?: string;
}

/**
 * Link to CivilGrid Support email via an `anchor` tag.
 *
 * ```tsx
 * import EmailLink from '~/components2/EmailLink';
 * ```
 *
 * @param {children} props.children - (required) JSX/text within the anchor tag;
 * @param {className} props.className - (optional) - Classnames to style the anchor tag.
 */

export default function EmailLink({ children, className, subject, email = 'support@civilgrid.com', ...rest }: Props) {
  const mailLink = `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;
  return (
    <a
      href={mailLink}
      target="_blank"
      rel="noopener noreferrer"
      className={cn('text-blue-50 underline hover:text-blue-60', className)}
    >
      {children}
    </a>
  );
}
